const sources = [{
  src: './images/slide-1.png',
  alt: 'slide-1'
}, {
  src: './images/slide-2.png',
  alt: 'slide-2'
}, {
  src: './images/slide-3.png',
  alt: 'slide-3'
}, {
  src: './images/slide-4.png',
  alt: 'slide-4'
}
];



export { sources };